import React from "react";
import { Outlet, Navigate } from "react-router-dom";

const AuthRoutes = () => {
  let auth = localStorage.getItem("Token");
  return auth ? <Outlet /> : <Navigate to="/Login" />;
};

export default AuthRoutes;
